import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import message from "./message";
// import { Notify } from "vant";
import { Dialog } from "vant";
import Pusher from "pusher-js";
import router from "../router/index";
import { axiosWithRetry } from "../assets/js/axiosHandler";
import { Toast } from "vant";

Vue.use(Vuex);

let idleTimer = null;

const domainTitleMap = {
  "pay.zhaofupay.com": "https://i.zhaofupay.com",
  "runn-f.test": "/",
  "running.etmart2.test": "/",
  "running.etmart2.com": "/",
  "running.etmart3.com": "/",
  "43.139.102.188": "http://43.139.102.188",
  "43.138.153.196": "http://43.138.153.196",
  "122.152.225.41": "http://122.152.225.41",
  "119.91.195.29": "http://119.91.195.29",
  "42.194.148.159": "http://42.194.148.159",
  "101.33.250.39": "http://101.33.250.39",
  "119.91.48.139": "http://119.91.48.139",
  "119.91.58.34": "http://119.91.58.34",
  "42.193.130.202": "http://42.193.130.202",
  "150.109.117.219": "http://150.109.117.219",
  "119.28.73.52": "http://119.28.73.52",
  "43.155.13.226": "http://43.155.13.226",
  "43.129.64.215": "http://43.129.64.215",
  "150.109.61.55": "http://150.109.61.55",
  "101.32.177.157": "http://101.32.177.157",
  "193.112.146.26": "http://193.112.146.26",
  "47.243.93.168": "http://47.243.93.168",
  "47.239.136.97": "http://47.239.136.97",
  "119.28.31.200": "http://119.28.31.200",
  "47.83.153.10": "http://47.83.153.10",
  "cn2.hdxa1110.com": "http://cn2.hdxa1110.com",
};

function isDomainAnIP() {
  const domain = document.domain;
  const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;
  return ipRegex.test(domain);
}

function getBaseURL() {
  let bU = domainTitleMap[document.domain];
  if (isDomainAnIP()) {
    bU = document.location.origin;
  }
  return bU || "https://888.ffb252.com";
}

function clonePlain(data) {
  return JSON.parse(JSON.stringify(data));
}

function mergeByOrderId(targetList = [], sourceList = []) {
  const list = Array.isArray(targetList) ? [...targetList] : [];
  const idSet = new Set(list.map((item) => item.order_id));

  sourceList.forEach((item) => {
    if (!idSet.has(item.order_id)) {
      list.push(item);
      idSet.add(item.order_id);
    }
  });

  return list;
}

function hasOrderById(list = [], orderId) {
  return list.some((item) => item.order_id == orderId);
}

function buildPagedData(oldState, incoming) {
  const current = clonePlain(oldState || { data: [] });
  current.data = mergeByOrderId(current.data, incoming?.data || []);
  current.current_page = incoming?.current_page;
  current.next_page = incoming?.next_page;
  return current;
}

function getUnreadChatCount(chatList = []) {
  let num = 0;
  chatList.forEach((item) => {
    if (item.read_at || item.from == "会员") return;
    num++;
  });
  return num;
}

function createPusherChannel({ context, channelName }) {
  let channel = null;

  const subscribeToChannel = () => {
    if (channel) {
      channel.unbind();
      window.pusher.unsubscribe(channelName);
    }

    channel = window.pusher.subscribe(channelName);

    channel.bind("pusher:subscription_error", (status) => {
      if (!window.__pusherHasShownError__) {
        console.error("訂閱失敗，狀態碼:", status);
        window.__pusherHasShownError__ = true;
      }
    });

    channel.bind(
      "Illuminate\\Notifications\\Events\\BroadcastNotificationCreated",
      (note) => {
        switch (note.type) {
          case "new_order":
            context.dispatch("noteNewOrder", note);
            context.dispatch("getSelf", "order_count");
            document
              .getElementById("orderAudio")
              ?.play()
              .catch(() => {
                Dialog.alert({ message: "您有新订单" });
              });
            break;

          case "new_payment":
            context.dispatch("noteNewPOrder", note);
            context.dispatch("getSelf", "payment_count");
            document
              .getElementById("paymentAudio")
              ?.play()
              .catch(() => {
                Dialog.alert({ message: "您有新订单" });
              });
            break;

          case "chat":
            if (!context.state.message.isChatOpen) {
              context.dispatch("message/showMessageBox", true);
            }
            if (note.from !== "会员") {
              document
                .getElementById("audio")
                ?.play()
                .catch(() => {});
            }
            note.id = note.message_id;
            context.dispatch("message/pushMsg", note);
            context.dispatch(
              "message/setUnreadNum",
              context.state.message.newMessagesCount + 1
            );
            break;
        }
      }
    );
  };

  return { subscribeToChannel };
}

export default new Vuex.Store({
  state: {
    isF: false,
    inChat: false,
    prohibitScroll: false,
    showOverlay: false,
    selfData: {},
    orders: {
      data: [],
    },
    pOrders: {
      data: [],
    },
    isLoadding: false,
    loadingTimer: null,
    isReLoadding: false,
    isInQuest: false,
    dateLocal: {
      direction: "ltr",
      format: "yyyy-mm-dd-HH:MM",
      separator: " - ",
      applyLabel: "确认",
      weekLabel: "W",
      cancelLabel: "取消",
      customRangeLabel: "Custom Range",
      daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
      monthNames: [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ],
      firstDay: 0,
      inNotify: false,
    },
    version: "",
    currentVersion: "2.0.0",
    except: {},
    isSubscribe: false,
    bindFADialog: false,
    isIdleMode: false,
  },

  mutations: {
    setVersion(state, data) {
      state.version = data;
    },

    setSelf(state, data) {
      state.selfData = {
        ...state.selfData,
        ...(data?.[0] || {}),
      };
    },

    OVERLAY(state, boolean) {
      state.showOverlay = boolean;
    },

    SETSUBSCRIBE(state) {
      state.isSubscribe = true;
    },

    SETSELF(state, data) {
      state.selfData = data;
    },

    SETORDERS(state, orders) {
      state.orders = orders;
    },

    PUSHORDERS(state, orders) {
      state.orders = buildPagedData(state.orders, orders);
    },

    PUSHPORDERS(state, orders) {
      state.pOrders = buildPagedData(state.pOrders, orders);
    },

    SETPORDERS(state, orders) {
      state.pOrders = orders;
    },

    setExcept(state, except) {
      state.except = {
        ...state.except,
        ...(except || {}),
      };
    },

    SETLODDING(state, boolean) {
      state.isLoadding = boolean;
      // if (boolean && !state.loadingTimer) {
      //   state.loadingTimer = setTimeout(() => {
      //     state.isLoadding = false;
      //     clearTimeout(state.loadingTimer);
      //     state.loadingTimer = null;
      //     alert("似乎遇到些问题，即将刷新页面。");
      //     window.location.reload(true);
      //   }, 20000);
      // }
      // if (!boolean && state.loadingTimer) {
      //   clearTimeout(state.loadingTimer);
      //   state.loadingTimer = null;
      // }
    },

    SETRELOAD(state, boolean) {
      state.isReLoadding = boolean;
    },

    SETINQUEST(state, boolean) {
      state.isInQuest = boolean;
    },

    SETSCROLL(state, boolean) {
      state.prohibitScroll = boolean;
    },

    PUSHNEWORDER(state, order) {
      if (hasOrderById(state.orders.data, order.order_id)) return;
      state.orders = {
        ...state.orders,
        data: [...state.orders.data, order],
      };
    },

    PUSHNEWPORDER(state, order) {
      if (hasOrderById(state.pOrders.data, order.order_id)) return;

      let nextOrder = order;
      if (typeof nextOrder.content == "string") {
        nextOrder = {
          ...nextOrder,
          content: JSON.parse(nextOrder.content),
        };
      }

      state.pOrders = {
        ...state.pOrders,
        data: [nextOrder, ...state.pOrders.data],
      };
    },

    BINDFA(state, boolean) {
      state.bindFADialog = boolean;
    },

    SET_IDLE_MODE(state, status) {
      state.isIdleMode = status;
    },

    SETUPDATE(state) {
      state.selfData = { ...state.selfData, on_duty_ds: 0 };
    },

    CLEARNSELF(state) {
      state.selfData = {};
    },

    SET_IN_CHAT(state, boolean) {
      state.inChat = boolean;
    },

    SET_IS_F(state, boolean) {
      state.isF = boolean;
    },
  },

  actions: {
    bindFA(context, boolean) {
      context.commit("BINDFA", boolean);
    },

    setProhibitScroll(context, boolean) {
      context.commit("SETSCROLL", boolean);
    },

    overlayHandler(context, boolean) {
      context.commit("OVERLAY", boolean);
    },

    initPusher(context, memberId) {
      const baseURL = getBaseURL();
      const token = localStorage.getItem("token");

      if (!token || !memberId) {
        console.warn("Missing token or memberId. Cannot initialize Pusher.");
        return;
      }

      if (window.pusher) {
        window.pusher.disconnect();
        window.pusher = null;
      }

      const channelName = `private-App.User.${memberId}`;
      let hasConnectedOnce = false;
      window.__pusherHasShownError__ = false;

      try {
        window.pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
          cluster: "ap3",
          authEndpoint: baseURL + "/broadcasting/auth",
          auth: {
            headers: {
              Authorization: "Bearer " + token,
            },
          },
        });

        const { subscribeToChannel } = createPusherChannel({
          context,
          channelName,
        });

        subscribeToChannel();

        window.pusher.connection.bind("error", (err) => {
          console.error("Pusher error:", err);
          if (!hasConnectedOnce && !window.__pusherHasShownError__) {
            window.__pusherHasShownError__ = true;
          }
        });

        window.pusher.connection.bind("connected", () => {
          hasConnectedOnce = true;
          console.log("Pusher reconnected. Resubscribing...");
          subscribeToChannel();
        });
      } catch (e) {
        console.error("Pusher 初始化錯誤:", e);
      }
    },

    disconnectPusher() {
      if (window.pusher) {
        window.pusher.disconnect();
        window.pusher = null;
      }
    },

    getSelf({ commit, state, dispatch }, payload = null) {
      setTimeout(() => {
        if (router.history.current.name == "goUrl") {
          return;
        }

        return axiosWithRetry({ method: "get", url: `/mobile/self` }).then(
          (res) => {
            if (res.data.code == 0) {
              commit("SET_IN_CHAT", true);

              const data = { ...res.data.data };

              if (payload) {
                if (data[payload] == state.selfData[payload]) {
                  data[payload] = state.selfData[payload] * 1 + 1;
                }
              }

              commit("SETSELF", data);

              if (!state.isF) {
                commit("SET_IS_F", true);

                axiosWithRetry({ method: "get", url: `/mobile/chat` }).then(
                  (res2) => {
                    let num = 0;
                    if (res2.data.code == 0) {
                      num = getUnreadChatCount(res2.data.data);
                    }
                    if (num) {
                      dispatch("message/setUnreadNum", num);
                    }
                  }
                );
              }

              if (!state.isSubscribe) {
                // axios.get(`/mobile/frontVersion`).then((version) => {
                //   if (version.data.code == 0) {
                //     state.version = version.data.data;
                //     commit("setVersion", version.data.data);
                //     if (state.currentVersion != version.data.data) {
                //       Notify({
                //         duration: 0,
                //         message: "为了最新体验，请重新整理或重启应用。",
                //         type: "danger",
                //       });
                //     }
                //   }
                // });
                commit("SETSUBSCRIBE", true);

                // socket
                dispatch("initPusher", res.data.data.member_id);
              }
            }
          }
        );
      }, 1000);
    },

    getOrder(context, params) {
      axios
        .get(`/mobile/orders`, {
          params,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (params && params.page != 1) {
              context.commit("PUSHORDERS", res.data);
            } else {
              context.commit("SETORDERS", res.data);
            }
            // context.commit("setExcept", res.data.except);
          }
        });
    },

    getPOrder(context, params) {
      const sendData = {
        ...(params || {}),
        sort: "desc",
      };

      axios.get(`/mobile/payments`, { params: sendData }).then((res) => {
        if (res.data.code == 0) {
          if (params && params.page != 1) {
            context.commit("PUSHPORDERS", res.data);
          } else {
            context.commit("SETPORDERS", res.data);
          }
          // context.commit("setExcept", res.data.except);
          // let order = JSON.parse(JSON.stringify(res.data.data));
          // order = order.sort((a, b) => {
          //   return b.member_id - a.member_id;
          // });
          // context.commit("SETPORDERS", order);
          // context.commit("setExcept", res.data.except);
        }
      });
    },

    setLoadding(context, boolean) {
      context.commit("SETLODDING", boolean);
    },

    setReload(context, boolean) {
      context.commit("SETRELOAD", boolean);
    },

    setWaitQuest(context, boolean) {
      context.commit("SETINQUEST", boolean);
    },

    noteNewOrder(context, order) {
      context.commit("PUSHNEWORDER", order);
    },

    noteNewPOrder(context, order) {
      context.commit("PUSHNEWPORDER", order);
    },

    useIdleTimeout({ commit, dispatch, state }, shouldStart) {
      if (
        !state.selfData.ds_close_duty ||
        !state.selfData.ds_close_duty.enable
      ) {
        clearTimeout(idleTimer);
        idleTimer = null;
        return;
      }

      const timeOutMin = state.selfData.ds_close_duty.minute;
      const timeoutDuration = (timeOutMin || 5) * 60 * 1000;
      let verifyTimeout = null;

      if (shouldStart) {
        if (idleTimer) {
          clearTimeout(idleTimer);
        }

        idleTimer = setTimeout(() => {
          commit("SET_IDLE_MODE", true);

          const verificationCode = Math.floor(
            1000 + Math.random() * 9000
          ).toString();

          verifyTimeout = setTimeout(() => {
            axios
              .post(`/mobile/personalSetting`, {
                on_duty_ds: false,
                idle: true,
              })
              .then((res) => {
                if (res.data.code == 0) {
                  Dialog.close();
                  commit("SETUPDATE");
                  dispatch("useIdleTimeout", false);
                  Dialog.confirm({
                    title: "闲置",
                    message: `因闲置时间过长，已自动关闭出货功能`,
                    showCancelButton: false,
                  });
                }
              });
          }, 60000);

          Dialog.confirm({
            title: "闲置验证",
            message: `请输入验证码以继续操作
              <strong style="font-size: 20px;">${verificationCode}</strong>
              <br/><input id="verify-input" type="text" 
                style="margin-top:10px;width:100%;border:1px solid #ccc;padding:6px;" />
            `,
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
            confirmButtonText: "确认",
            beforeClose: (action, done) => {
              setTimeout(() => {
                const input = document.getElementById("verify-input");
                if (input && input.value === verificationCode) {
                  console.log("验证成功");
                  clearTimeout(verifyTimeout);
                  dispatch("getSelf");
                  commit("SET_IDLE_MODE", false);
                  dispatch("useIdleTimeout", true);
                  done();
                } else {
                  console.log("验证失败");
                  Toast.fail("验证码错误，请重新输入");
                  done(false);
                }
              }, 0);
            },
          });

          document.getElementById("audio")?.play();
          console.log("使用者閒置，顯示驗證 Dialog");
        }, timeoutDuration);

        commit("SET_IDLE_MODE", false);
      } else {
        if (idleTimer) {
          clearTimeout(idleTimer);
          idleTimer = null;
        }
        commit("SET_IDLE_MODE", false);
      }
    },
  },

  modules: {
    message,
  },
});
